<template>
    <a
        href="https://www.instagram.com/holisticsportcenter/"
        target="_blank"
        rel="noopener noreferrer"
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M10.0011 4.79883C7.17855 4.79883 4.83984 7.09721 4.83984 9.96012C4.83984 12.823 7.13823 15.1214 10.0011 15.1214C12.864 15.1214 15.1624 12.7827 15.1624 9.96012C15.1624 7.13754 12.8237 4.79883 10.0011 4.79883ZM10.0011 13.2666C8.18662 13.2666 6.69468 11.7746 6.69468 9.96012C6.69468 8.1456 8.18662 6.65367 10.0011 6.65367C11.8156 6.65367 13.3076 8.1456 13.3076 9.96012C13.3076 11.7746 11.8156 13.2666 10.0011 13.2666Z"
                fill="#E30613"
            />
            <path
                d="M15.3647 5.84652C16.0105 5.84652 16.534 5.32298 16.534 4.67717C16.534 4.03135 16.0105 3.50781 15.3647 3.50781C14.7189 3.50781 14.1953 4.03135 14.1953 4.67717C14.1953 5.32298 14.7189 5.84652 15.3647 5.84652Z"
                fill="#E30613"
            />
            <path
                d="M18.3871 1.65323C17.3387 0.564516 15.8468 0 14.1532 0H5.84677C2.33871 0 0 2.33871 0 5.84677V14.1129C0 15.8468 0.564516 17.3387 1.69355 18.4274C2.78226 19.4758 4.23387 20 5.8871 20H14.1129C15.8468 20 17.2984 19.4355 18.3468 18.4274C19.4355 17.379 20 15.8871 20 14.1532V5.84677C20 4.15323 19.4355 2.70161 18.3871 1.65323ZM18.2258 14.1532C18.2258 15.4032 17.7823 16.4113 17.0565 17.0968C16.3306 17.7823 15.3226 18.1452 14.1129 18.1452H5.8871C4.67742 18.1452 3.66935 17.7823 2.94355 17.0968C2.21774 16.371 1.85484 15.3629 1.85484 14.1129V5.84677C1.85484 4.6371 2.21774 3.62903 2.94355 2.90323C3.62903 2.21774 4.67742 1.85484 5.8871 1.85484H14.1935C15.4032 1.85484 16.4113 2.21774 17.1371 2.94355C17.8226 3.66935 18.2258 4.67742 18.2258 5.84677V14.1532Z"
                fill="#E30613"
            />
        </svg>
    </a>
</template>

<script>
export default {
    name: "InstagramRed",
};
</script>
